module.exports = __webpack_public_path__ + "img/letras_healthtech_colosio.ab82a2e5.jpg";